import { io } from 'socket.io-client';

let socket;

export const initializeSocket = (token) => {
  if (!socket) {
    socket = io('https://api.trackex.co', {
      path: '/qrwetyuin8b3b024b3da067fcf598dea6',
      transports: ['polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      autoConnect: false,
      auth: {
        token
      }
    });
  }
  return socket;
};

export const getSocket = () => socket;
